<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Salary Sub Component Master</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row class="no-display" justify="center" dense>
                    <v-col cols="12" sm="2" md="2" class="pt-4">
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="calendar_year"
                            :items="calendar_year_list"
                            @change="getSalaryMonths()"
                            item-text="name"
                            item-value="id"
                            label="Year"
                            outlined
                            persistent-hint
                            hint="Please Select Year"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="pt-4" v-if="this.salary_month_list!=''">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="salary_month" :items="salary_month_list" item-text="sal_mon" return-object label="Month" outlined persistent-hint hint="Please Select Month" />
                    </v-col>
                    <v-col cols="12" md="2" sm="2" class="pt-4">
                        <v-autocomplete rounded outlined dense v-model="empid" :items="employee_list" item-text="employee_code" item-value="employee_id" label="Select Employee" />
                    </v-col>
                    <v-col cols="12" md="2" sm="2" class="pt-4">
                        <v-autocomplete rounded outlined dense v-model="salary_component" :items="salary_component_list" item-text="name" return-object label="Select Salary Component" />
                    </v-col>
                    <v-col cols="12" md="2" sm="2">
                        <v-btn rounded class="button" v-if="salary_month && salary_component" @click="getEmployeeSubComponentDetails()" :loading="loader">Fetch</v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="salary_sub_comp_list!=null" class="no-display" justify="center" dense>
                    <v-toolbar flat dense class="toolbar no-display">
                        <v-toolbar-title>Salary Sub Component</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-row>
                <v-row v-if="salary_sub_comp_list!=null" class="no-display" justify="center" dense>
                    <v-col cols="12" md="3" sm="3">
                        <v-autocomplete @change="addsubcompvalue(salary_sub_comp)" rounded outlined dense v-model="salary_sub_comp" :items="salary_sub_comp_list" item-text="name" return-object label="Select Salary Sub Component" />
                    </v-col>
                </v-row>
                <v-row v-if="salary_sub_comp_values!=''" class="no-display" justify="center" dense>
                    <v-toolbar flat dense class="toolbar no-display">
                        <v-toolbar-title>Enter Salary Sub Component Values</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-row>
                <v-row v-if="salary_sub_comp_values!=''" class="no-display" justify="center" dense>
                    <v-col cols="12" md="3" sm="3" class="pt-4" v-for="s,index in this.salary_sub_comp_values" :key="index">
                        <v-text-field class="pt-3" type="number" :label="s.name" rounded outlined dense v-model="s.value"></v-text-field>
                        <v-text-field class="pt-3" type="number" label="Sub Component Details(Unique No.)" persistent-hint :hint="'For example :: 1432423132, 34543, 421341...'" rounded outlined dense v-model="s.details"></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="salary_sub_comp_values!='' && salary_month && salary_component" class="no-display" justify="center" dense>
                    <!-- <v-btn rounded class="button" v-if="salary_month && salary_component" @click="saveSubComponentMasterSingle()" :loading="loader">Save</v-btn> -->
                    <v-col cols="12" sm="12" md="12">
                        <center><v-btn rounded class="button" v-if="salary_month && salary_component" @click="save_confirmation()" :loading="loader">Save</v-btn></center>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                        <center><strong> Note: Once all sub components are added to "{{salary_component.name}}", then click save botton. </strong></center>
                    </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="12" v-if="employee_details_list!=''">
                    <div id="my-table-id">
                        <v-data-table :items-per-page="-1" :headers="headers" dense :items="employee_details_list" class="elevation-1 mytable">
                            <template v-slot:top>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong>
                                            Salary Sub Component Master
                                        </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <br />
                            </template>
                            <template v-slot:item.iscurrent="{ item }">
                                <center><v-switch @change="changeSalarySubComponentMasterStatus(item.sub_comp_master_id,item.iscurrent,item.employee_id,item.salary_component)" color="#0F2027" v-model="item.iscurrent"></v-switch></center>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-avatar :disabled="disabled == salary_month.isfreezed ? true : false" style="" size="25" class="edit-avatar" @click="editItem(item.sub_comp_master_id)">
                                    <v-icon :disabled="disabled == salary_month.isfreezed ? true : false" x-small class="edit-v-icon mr-2">edit</v-icon>
                                </v-avatar>
                            </template>
                        </v-data-table>
                    </div>
                </v-col>
                <!--<center> <v-btn v-if="employee_details_list!=''" :disabled="disabled == salary_month.isfreezed ? true : false"  @click="saveSubComponentMaster(employee_details_list)"  :loading="load" class="button no-display">Save / Update</v-btn></center> -->
            </v-card>

            <v-dialog v-model="save_dialog" max-width="600px" v-if="salary_component">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row dense justify="center">
                                <strong>Are you sure want to save, the total amount in "{{salary_component.name}}" is {{ total_sub_amt }} ?</strong>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-row dense justify="center">
                        <v-btn class="button" @click="saveSubComponentMasterSingle()">Yes</v-btn>
                        <v-btn class="button" @click="save_dialog = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="update_dialog" max-width="600px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row dense justify="center">
                                <strong>Are you sure want to update salary sub master, the total amount is {{ total_sub_amt_edit }} ?</strong>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-row dense justify="center">
                        <v-btn class="button" @click="updateSubComponentMaster()">Yes</v-btn>
                        <v-btn class="button" @click="update_dialog = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_edit" max-width="1200px" v-if="sub_comp_master_details!=''">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar flat dense class="toolbar no-display">
                        <v-toolbar-title>Edit Salary Sub Component Master Of {{ sub_comp_master_details[0].sub_comp_master_salary_component }} - {{ sub_comp_master_details[0].sub_comp_master_salary_month }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                        <v-card class="box">
                            <v-row dense justify="center">
                                <v-col cols="12" md="4" sm="4" class="pt-4" v-for="s,index in sub_comp_master_details[0].sub_comp_details" :key="index">
                                    <v-card flat class="box">
                                        <v-text-field class="pt-3" type="number" :label="s.salary_sub_component"  dense v-model="s.smd_value"></v-text-field>
                                        <v-text-field class="pt-3" type="number" label="Sub Component Details(Unique No.)" persistent-hint :hint="'For example :: 1432423132, 34543, 421341...'"  dense v-model="s.sub_component_details"></v-text-field>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-row dense justify="center">
                        <v-btn class="button" @click="update_confirmation()">Yes</v-btn>
                        <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            selected: [],
            loader: false,
            radios: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            title: "",
            description: "",
            search: "",
            show: false,
            empid: null,
            calendar_year_list: [],
            calendar_year: "",
            salary_month_list: [],
            salary_month: "",
            employee_details_list: [],
            employee_list: [],
            salary_sub_comp_list: null,
            salary_sub_comp: null,
            org_basic_data: [],
            salary_component_list: [],
            salary_component: null,
            salary_sub_comp_values: [],
            org_id: null,
            total_sub_amt: null,
            save_dialog: false,
            sub_comp_master_id: null,
            sub_comp_master_details: [],
            total_sub_amt_edit:[],
            dialog_edit: false,
            update_dialog:false,
            headers: [
                {
                    text: "Employee",
                    align: "center",
                    sortable: false,
                    value: "employee_code",
                },
                {
                    text: "Salary Month",
                    align: "center",
                    sortable: false,
                    value: "sal_month",
                },
                {
                    text: "Value",
                    align: "center",
                    sortable: false,
                    value: "value",
                    width: 300,
                },
                {
                    text: "Is current ?",
                    sortable: false,
                    value: "iscurrent",
                },
                {
                    text: "Action",
                    align: "center",
                    sortable: false,
                    value: "action",
                },
            ],
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            addsubcompvalue(salary_sub_comp) {
                for (var i = 0; i < this.salary_sub_comp_values.length; i++) {
                    if(this.salary_sub_comp_values[i].id == salary_sub_comp.id){
                        //alert("in if")
                        return
                    }
                }
                this.salary_sub_comp_values.push({ name: salary_sub_comp.name, id: salary_sub_comp.id, value: 0, details: null });
            },
            save_confirmation() {
                this.total_sub_amt = null;
                for (var i = 0; i < this.salary_sub_comp_values.length; i++) {
                    this.total_sub_amt = this.total_sub_amt + parseFloat(this.salary_sub_comp_values[i].value);
                }
                this.save_dialog = true;
            },
            update_confirmation() {
                this.total_sub_amt_edit = null;
                for (var i = 0; i < this.sub_comp_master_details[0].sub_comp_details.length; i++) {
                    this.total_sub_amt_edit = this.total_sub_amt_edit + parseFloat(this.sub_comp_master_details[0].sub_comp_details[i].smd_value);
                }
                this.update_dialog = true;
            },
            async updateSubComponentMaster(){
               const data={
                    sub_comp_master_id:this.sub_comp_master_details[0].sub_comp_master_id,
                    sub_comp_details:this.sub_comp_master_details[0].sub_comp_details
               }
                try {
                    const res = await axios.post("/Payroll/updateSubComponentMaster", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Updated successfully!!!");
                        this.getEmployeeSubComponentDetails();
                        this.update_dialog = false;
                        this.dialog_edit = false;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.update_dialog = false;
                    this.dialog_edit = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.update_dialog = false;
                    this.dialog_edit = false;
                } finally {
                    this.update_dialog = false;
                    this.dialog_edit = false;
                    this.total_sub_amt_edit = null
                }
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            async editItem(sub_comp_master_id) {
                //alert(sub_comp_master_id)
                 this.sub_comp_master_id = sub_comp_master_id
                 const data={
                    sub_comp_master_id :this.sub_comp_master_id
                 }
                try {
                    const res = await axios.post("/Payroll/getSalarySubComponentMasterInfo", data);
                    if (res.data.flag == "YES") {
                        this.sub_comp_master_details = res.data.sub_comp_master_details;
                        this.dialog_edit = true;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                } finally {
                }
            },
            async changeSalarySubComponentMasterStatus(sub_comp_master_id, iscurrent, employee_id, salary_component) {
                const data = {
                    id: sub_comp_master_id,
                    iscurrent: iscurrent,
                    emp_id: employee_id,
                    salary_component: salary_component,
                };
                try {
                    const res = await axios.post("/Payroll/changeSalarySubComponentMasterStatus", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved successfully!!!");
                        this.getEmployeeSubComponentDetails();
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                } finally {
                   
                }
            },
            async saveSubComponentMasterSingle() {
                const data = {
                    sal_month: this.salary_month.id,
                    emp_id: this.empid,
                    salary_component: this.salary_component.id,
                    sub_comp_values: this.salary_sub_comp_values,
                };
                try {
                    const res = await axios.post("/Payroll/saveSubComponentMasterSingle", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved successfully!!!");
                        this.getEmployeeSubComponentDetails();
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_dialog = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.save_dialog = false;
                } finally {
                    (this.salary_sub_comp_values = []), (this.salary_sub_comp_list = []), (this.salary_sub_comp = null);
                    this.save_dialog = false;
                    this.total_sub_amt = null
                }
            },
            async getEmployeeSubComponentDetails() {
                this.employee_details_list = [];
                this.salary_sub_comp_list = [];
                this.salary_sub_comp_values = [];
                const data = {
                    sal_month: this.salary_month.id,
                    emp_id: this.empid,
                    salary_component: this.salary_component.id,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Payroll/getEmployeeSubComponentDetails", data);
                    if (res.data.flag == "YES") {
                        this.employee_details_list = res.data.employee_details_list;
                        this.salary_sub_comp_list = res.data.salary_sub_comp_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            setNull() {
                (this.salary_month_list = []), (this.salary_month = "");
            },
            getSalaryMonths() {
                this.setNull();
                const data = {
                    year: this.calendar_year,
                };
                this.overlay = true;
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.salary_month_list = res.data.sal_month_list;
                            this.employee_list = res.data.employee_list;
                            this.salary_component_list = res.data.salary_component_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            onLoad() {
                axios
                    .post("EmployeeBiometric/getPayrollInfo")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.calendar_year_list = res.data.calendar_year_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    thead {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        /* font-size: small; */
    }
    tr,
    tbody {
        /* border-bottom: 1px solid black; */
        border: 1px solid black;
        /* font-size: small; */
    }
    /* td {
        font-size: small;
    } */
    .msg {
        font-weight: Normal !important;
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    @media print {
        /* td {
                font-size: 15px !important;
                padding:10px;
            }
            th{
                font-size: 15px !important;
            } */
        @page {
            size: A3 !important;
            scale: 50 !important;
            margin-top: none !important;
            padding-top: none !important;
            /* size: 400mm 100mm; */
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
    }
</style>
